<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <h1>{{ $t("tracking.cargo.edit") }}</h1>
        <success-fade-alert ref="alert" :msg="alert.success" />
        <fade-alert-danger ref="danger" :msg="alert.error" />
        <!-- <div>Permissions {{ permissions }}</div> -->
        <b-row class="mb-3 ml-0">
          <router-link :to="getUrlBackToList">
            <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
          </router-link>
          <div div v-if="permissions == 1">
            <!-- ativa a carga -->
            <div v-if="releases.canActivateLoads">
              <b-button
                v-if="!isCargoActive(model)"
                size="sm"
                class="btn-checklist ml-2"
                @click="openModal()"
              >
                {{ $t("geral.activate") }}
              </b-button>
              <b-modal
                v-if="!isCargoActive(model)"
                ref="openModal"
                class="statusChange"
                scrollable
                size="sm"
                @ok="cargoActivate(model)"
              >
                <b-form-group
                  :label="$t('tracking.cargo.reasonForStatusChange')"
                  label-for="reasonForStatusChange"
                >
                  <b-form-input
                    type="text"
                    id="ReasonForStatusChange"
                    :placeholder="$t('tracking.cargo.reasonForStatusChange')"
                    v-model="model.reasonForStatusChangeText"
                  />
                </b-form-group>
                <template #modal-footer="{ ok, cancel }">
                  <div class="right">
                    <b-button variant="green" @click="ok()">
                      {{ $t("geral.confirm") }}
                    </b-button>
                    <b-button class="ml-2" variant="danger" @click="cancel()">
                      {{ $t("geral.cancel") }}
                    </b-button>
                  </div>
                </template>
              </b-modal>
            </div>
            <!-- desativa a carga -->
            <div v-if="releases.canDeleteLoads">
              <b-button
                v-if="isCargoActive(model)"
                size="sm"
                class="btn-checklist ml-2"
                @click="openModal()"
              >
                {{ $t("geral.delete") }}
              </b-button>
              <b-modal
                v-if="isCargoActive(model)"
                ref="openModal"
                class="statusChange"
                scrollable
                size="sm"
                @ok="cargoDeactivate(model)"
              >
                <b-form-group
                  :label="$t('tracking.cargo.reasonForStatusChange')"
                  label-for="reasonForStatusChange"
                >
                  <b-form-input
                    type="text"
                    id="ReasonForStatusChange"
                    :placeholder="$t('tracking.cargo.reasonForStatusChange')"
                    v-model="model.reasonForStatusChangeText"
                  />
                </b-form-group>
                <template #modal-footer="{ ok, cancel }">
                  <div class="right">
                    <b-button variant="green" @click="ok()">
                      {{ $t("geral.confirm") }}
                    </b-button>
                    <b-button class="ml-2" variant="danger" @click="cancel()">
                      {{ $t("geral.cancel") }}
                    </b-button>
                  </div>
                </template>
              </b-modal>
            </div>
          </div>
        </b-row>
        <div v-if="permissions == 2">
          <cargo-crud-data
            ref="cargoCrudData"
            :model="model"
            :modelstate="modelstate"
            :readonly="canEdit"
            :create="false"
            class="mb-4"
          >
          </cargo-crud-data>
        </div>

        <div v-else-if="permissions == 1">
          <cargo-crud-data
            ref="cargoCrudData"
            :model.sync="model"
            :modelstate="modelstate"
            :readonly="!canEdit"
            class="mb-4"
          >
          </cargo-crud-data>
          <!-- {{model.cargoPath}} -->
          <cargo-path
            :items.sync="model.cargoPath"
            :carga.sync="model"
            :modelstate="modelstate"
            :readonly="canEdit"
          >
          </cargo-path>
          <div v-if="!modal">
            <b-button
              class="button"
              @click="save($event)"
              :disabled="canSubmit"
            >
              {{ $t("geral.save") }}
            </b-button>
          </div>
        </div>
        <div v-else>
          <h4>Você não possui acesso a edição desta esta carga</h4>
        </div>
      </b-col>
    </b-row>
    <div class="mt-5" v-if="model.permissions != 2">
      <cargo-story ref="cargoStory" :cargo-id="getCargoId"> </cargo-story>
    </div>
  </b-container>
</template>
<script>
import CargoStory from "@/components_rms/tracking/cargo/CargoStory.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  name: "CargoEditData",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    CargoStory,
    CargoCrudData: () =>
      import("@/components_rms/tracking/cargo/CargoCrudData.vue"),
    CargoPath: () => import("@/components_rms/tracking/cargo/CargoPath.vue"),
  },
  props: {
    id: String,
    companyId: String,
    modal: Boolean,
    cargo: Object,
    modelstate: Object,
    permission: Number,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      submitted: false,
      model: {},
      releases: {
        canActivateLoads: false,
        canDeleteLoads: false,
      },
      timer: null,
      permissions: 0,
    };
  },
  mounted() {
    this.getPermision();
    this.loadData();
  },
  computed: {
    canEdit() {
      if (!this.model) {
        return false;
      }
      if (!this.model.cargoActive) {
        return true;
      }
      return true;
    },
    canSubmit() {
      if (this.submitted) {
        return true;
      }
      if (!this.canEdit) {
        return true;
      }
      return false;
    },
    getUrlBackToList() {
      if (this.companyId) {
        return `../../cargo/list/${this.companyId}`;
      }
      return `../../cargo/list`;
    },
    getUrlCargoList() {
      if (this.companyId) {
        return `cargo/get/${this.id}/${this.companyId}`;
      }
      return `cargo/get/${this.id}`;
    },
    getUrlPermission() {
      return `v1/getOccurrencePermissions/${this.id}`;
    },
    getCargoId() {
      if (!this.id) return 0;
      if (this.id.trim() == "") return 0;
      return parseInt(this.id);
    },
  },
  methods: {
    openModal() {
      this.$refs.openModal.show();
      this.model.reasonForStatusChangeText = "";
    },
    async loadData() {
      this.$api
        .get(this.getUrlCargoList)
        .then((response) => {
          let model = response.data;
          if (model.status == 13) model.status = 1;
          this.profileRelease();
          this.model = model;
          // this.getPermision();
          this.$emit("update:cargo", this.model);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                if (error.response.data.errors) {
                  this.modelstate = error.response.data.errors;
                } else {
                  this.modelstate = error.response.data;
                }
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    getPermision() {
      this.$api
        .get(this.getUrlPermission)
        .then((response) => {
          this.$emit("update:permission", response.data.permissions);
          this.permissions = response.data.permissions;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    cargoActivate(cargo) {
      this.$api
        .post("/cargo/activate/" + cargo.cargoId.toString(), this.model)
        .then((response) => {
          if (response.data.success == false) {
            this.alert.error = response.data.title;
            this.$refs.danger.show();
          } else {
            cargo.cargoActive = true;
            this.alert.success = response.data.title;
            this.$refs.alert.show();

            this.model.reasonForStatusChange =
              this.model.reasonForStatusChangeText;
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          if (error.response.status == 400) {
            if (error.response.data.errors) {
              this.modelstate = error.response.data.errors;
            } else {
              this.modelstate = error.response.data;
            }
          } else {
            this.alert.error =
              error.response.status + " - " + error.response.statusText;
            this.$refs.danger.show();
          }
        });
    },
    cargoDeactivate(cargo) {
      this.$api
        .post("/cargo/deactivate/" + cargo.cargoId.toString(), this.model)
        .then((response) => {
          if (response.data.success == false) {
            this.alert.error = response.data.title;
            this.$refs.danger.show();
          } else {
            cargo.cargoActive = false;
            this.alert.success = response.data.title;
            this.$refs.alert.show();

            this.model.reasonForStatusChange =
              this.model.reasonForStatusChangeText;
            this.$forceUpdate();
          }
          // this.alert.error = response.data.title;
          // this.$refs.danger.show();
          // this.model.reasonForStatusChange =
          //   this.model.reasonForStatusChangeText;
          // this.$forceUpdate();
          // cargo.cargoActive = false;
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    isCargoActive(cargo) {
      if (cargo) {
        return cargo.cargoActive;
      }
      return false;
    },
    tripTotalKmType() {
      if (this.model.tripTotalKm === "" || this.model.tripTotalKm == 0) {
        return (this.model.tripTotalKm = null);
      }
    },
    save(e) {
      this.tripTotalKmType();

      this.submitted = true;
      this.$refs.cargoCrudData.dataFormat();
      this.$api
        .post("/cargo/edit/" + this.model.cargoId.toString(), this.model)
        .then((response) => {
          this.model = response.data;
          // this.$forceUpdate();
          this.$refs.cargoStory.refresh();
          // this.$refs.cargoPath.refresh();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
          e.preventDefault();
          this.$emit("update:cargo", this.model);
          this.$emit("confirmEdit");
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log("error");
          console.log(error);
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            console.log(error.response);
            console.log(error.response.data.errors);
            if (error.response.status == 400) {
              if (error.response.data.errors) {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
            } else if (error.response.status == 500) {
              if (error.response.data.detail != null)
                this.alert.error = error.response.data.detail;
              else this.alert.error = error.response.data;
              this.$refs.danger.show();
              console.log("model");
              console.log(this.model);
              this.model.cargoPath.originCityId = 0;
              this.model.cargoPath.originStateId = 0;
              this.model.cargoPath.destinationCityId = 0;
              this.model.cargoPath.destinationStateId = 0;
            } else if (error.response.status == 404) {
              console.log("ok");
              console.log(error.response.data);
              this.alert.error = error.response.data.message;
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    profileRelease() {
      this.$api
        .get("/v1/profile/user/releases")
        .then((response) => {
          this.releases.canActivateLoads = response.data.canActivateLoads;
          this.releases.canDeleteLoads = response.data.canDeleteLoads;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
  watch: {
    stateId() {
      this.getPermision();
      this.loadData();
    },
  },
};
</script>
